import CloseIcon from '@mui/icons-material/Close';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { AppButton } from '../../Components/AppButton';

const useStyles = makeStyles((theme) => ({
  padding: {
    padding: '16px',
  },
}));

export default function KenDialog(props) {
  const {
    open,
    handleClose,
    title,
    dialogText,
    negativeButtonText,
    positiveButtonText,
    dialogContent,
    dialogActions,
    children,
    titleContainerStyles,
    maxWidth,
    dialogActionProps,
    negativeButtonClick,
    positiveButtonClick,
    hidePositiveButton,
    hideNegativeButton,
    onClose,
    hideCustomPositiveButton,
    customPositiveButtonText,
    customPositiveButtonStyle,
    minWidth = '362px',
  } = props;

  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      PaperProps={{
        sx: {
          margin: 0, minWidth: minWidth,
          '@media (max-width:626px)': {
            minWidth: '100%',
          },
        },
      }}
      maxWidth={maxWidth}
      style={{ margin: 20 }}
    >
      <DialogTitle id="form-dialog-title" classes={{ root: classes.padding }} style={{ ...titleContainerStyles }}>
        {title}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      {dialogContent || (
        <>
          {dialogText && (
            <DialogContent classes={{ root: classes.padding }}>
              {dialogText && <DialogContentText>{dialogText}</DialogContentText>}
            </DialogContent>
          )}
        </>
      )}

      <DialogContent classes={{ root: classes.padding }}>{children ? children : null}</DialogContent>
      {dialogActions && (
        <DialogActions style={{ marginBottom: "0px 24px 26px 10px" }} {...dialogActionProps}>
          {!hideNegativeButton && (
            < Button variant='contained' color='secondary' size='medium' onClick={negativeButtonClick}>
              {negativeButtonText || 'Cancel'}
            </Button>

          )}
          {!hidePositiveButton && (
            <Button variant='contained' color='primary' size='medium' onClick={positiveButtonClick}>
              {positiveButtonText || 'Ok'}
            </Button>

          )}
          {!hideCustomPositiveButton && (
            <Button
              variant='contained'
              color='error'
              size='medium'
              onClick={positiveButtonClick}
              sx={{padding:'8px'}}
            >
              {customPositiveButtonText || 'Ok'}
            </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
}
